import * as Utils from '@ext/index';
import { Modelo } from '@ext/index';



export class Estados
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Estados
    {

        if ( id === this.Activa.Id ) return this.Activa;
        else if ( id === this.Pausada.Id ) return this.Pausada;
        else if ( id === this.Cerrada.Id ) return this.Cerrada;
        return new Estados( id, id.toString() );
    }

    public static Activa: Estados = new Estados( "active", "Activa" );
    public static Pausada: Estados = new Estados( "paused", "Pausada" );
    public static EnRevision: Estados = new Estados( "under_review", "En revisión" );
    public static Inactiva: Estados = new Estados( "inactive", "En revisión" );
    public static Cerrada: Estados = new Estados( "closed", "Cerrada" );

    public get esActiva(): boolean { return this.Id === Estados.Activa.Id; }
    public get esPausada(): boolean { return this.Id === Estados.Pausada.Id; }
    public get esCerrada(): boolean { return this.Id === Estados.Cerrada.Id; }

    public static Filter = [
        { Id: 0, Nombre: 'Todos', Valor: [] },
        { Id: 1, Nombre: Estados.Activa.Descripcion, Valor: [Estados.Activa] },
        { Id: 2, Nombre: Estados.Pausada.Descripcion, Valor: [Estados.Pausada] },
        { Id: 3, Nombre: Estados.Cerrada.Descripcion, Valor: [Estados.Cerrada] },
    ];
}

export class Tipos
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Tipos
    {

        if ( id === this.Normal.Id ) return this.Normal;
        else if ( id === this.Financiada.Id ) return this.Financiada;
        return new Tipos( id, id.toString() );
    }

    public static Normal: Tipos = new Tipos( "gold_special", "Normal" );
    public static Financiada: Tipos = new Tipos( "gold_pro", "Financiada" );

    public get esNormal(): boolean { return this.Id === Tipos.Normal.Id; }
    public get esFinanciada(): boolean { return this.Id === Tipos.Financiada.Id; }

    public static Filter = [
        { Id: 0, Nombre: 'Todos', Valor: [] },
        { Id: 1, Nombre: Tipos.Normal.Descripcion, Valor: [Tipos.Normal] },
        { Id: 2, Nombre: Tipos.Financiada.Descripcion, Valor: [Tipos.Financiada] },
    ];
}

export class TiposEnvio
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): TiposEnvio
    {

        if ( id === this.ErrorEnCodigo.Id ) return this.ErrorEnCodigo;
        else if ( id === this.NoEspecificado.Id ) return this.NoEspecificado;
        else if ( id === this.ME2.Id ) return this.ME2;
        else if ( id === this.ME1.Id ) return this.ME1;
        return new TiposEnvio( id, id.toString() );
    }

    public static ErrorEnCodigo: TiposEnvio = new TiposEnvio( "error_codigo", "Error en codigo" );
    public static NoEspecificado: TiposEnvio = new TiposEnvio( "not_specified", "A acordar" );
    public static ME2: TiposEnvio = new TiposEnvio( "me2", "MercadoEnvios 2" );
    public static ME1: TiposEnvio = new TiposEnvio( "me1", "MercadoEnvios 1" );

    public get esEnvioGratis(): boolean { return this.Id === TiposEnvio.ME2.Id; }
    public get esNoEspecificado(): boolean { return this.Id === TiposEnvio.NoEspecificado.Id; }
    public get esErrorEnCodigo(): boolean { return this.Id === TiposEnvio.ErrorEnCodigo.Id; }

    public static Filter = [
        { Id: 0, Nombre: 'Todos', Valor: [] },
        { Id: 1, Nombre: TiposEnvio.NoEspecificado.Descripcion, Valor: [TiposEnvio.NoEspecificado, TiposEnvio.ErrorEnCodigo] },
        { Id: 2, Nombre: TiposEnvio.ME2.Descripcion, Valor: [TiposEnvio.ME2] },
        { Id: 2, Nombre: TiposEnvio.ME1.Descripcion, Valor: [TiposEnvio.ME1] },
    ];
}


export class Atributo extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Publicacion: string;
    public Atributo: string;
    public Valor: string;

    public getJson()
    {

        let Json: any = {};
        Json.publicacion = this.Publicacion;
        Json.atributo = this.Atributo;
        Json.valor = this.Valor;
        return Json;
    }

    public set()
    {
        this.Publicacion = this.Json.publicacion;
        this.Atributo = this.Json.atributo;
        this.Valor = this.Json.valor;
        this.Existe = true;
        return this.Existe;
    }
}


export class Imagen extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Publicacion: string;
    public Link: string;
    public esVideo: boolean = false;
    public Id: string;

    public getJson()
    {

        let Json: any = {};
        Json.publicacion = this.Publicacion;
        Json.link = this.Link;
        Json.id = this.Id;
        return Json;
    }

    public set()
    {
        this.Publicacion = this.Json.publicacion;
        this.Link = this.Json.link;
        this.Id = this.Json.id;
        this.Existe = true;
        return this.Existe;
    }
}